export const MIN_CHAR_AUTO_COMPLETE = 3;
